import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const Page_Header_Metier = () => {
  const { metierId } = useParams(); // Récupère l'id depuis l'URL
  const [titre, setTitre] = useState(''); // État pour stocker le titre du métier
  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    if (!metierId) {
      console.error('ID du métier non fourni !');
      return;
    }

    axios
      .get(`${Url}/api/FicheMetierRouter/id/${metierId}`)
      .then((response) => {
        console.log("Réponse de l'API métier :", response.data);
        const metier = response.data.data;
        if (metier && metier.metierTitle) {
          setTitre(metier.metierTitle);
        } else {
          console.error('Aucun titre trouvé pour ce métier.');
        }
      })
      .catch((error) => {
        console.error(
          'Erreur lors de la récupération du titre du métier :&apos;',
          error,
        );
      });
  }, [metierId]);

  return (
    <div className="breadcrumb-area bg-overlay">
      <div className="container">
        <div className="breadcrumb-inner">
          <div className="section-title mb-0 text-center">
            <h2 className="page-title">{titre}</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Page_Header_Metier;
